module.exports = __webpack_public_path__ + "static/media/view admitted staff.ff27474a.svg";